<template>
	<div class="page_goods">
		<cube-page type="Goods-view" title="商品详情">
			<div slot="content">
				<van-swipe :autoplay="3000" :indicator-color="gcfg.BackgroundColor" class="swipebox">
					<van-swipe-item v-for="(image, index) in detail.imgs_url" :key="index">
						<!-- <van-image :src="image" fit="cover" lazy-load /> -->
						<img v-lazy="image" />
					</van-swipe-item>
				</van-swipe>

				<van-cell-group>
					<van-cell :title="detail.goods_name" :border="false"
						style="font-size:1.2em;margin-bottom:-0.5em;font-weight: bold;" />
					<van-cell value="" title-class='titlec'>
						<template slot="icon">
							<van-icon name="discount" size="1.8em" style="margin-right:0.3em;" />
						</template>
						<template slot="title">
							<span class="van-cell-text">同行价：</span>
							<van-tag mark size="large" type="danger">￥{{goods_price}} 起</van-tag>
						</template>
						<div>
							零售价：￥{{line_price}}
						</div>
					</van-cell>
					<van-cell :title="'库存：'+stock_num" :value="'销量:'+goods_sales" />
				</van-cell-group>
				<div class="modal_cont_box">
					<div class="til_conview">
						<van-row class='in-title'>
							<van-col>
								<van-icon name="column" :color="gcfg.BackgroundColor" size="2em" />
							</van-col>
							<van-col><span class="til_con"> 商品描述 </span></van-col>
						</van-row>
					</div>
					<div class="goods-cont-li">
						<div v-html="detail.content"></div>
					</div>

					<Copyright style="margin-bottom:4em"></Copyright>

				</div>
				<van-goods-action>
					<van-goods-action-button type="danger" text="立即购买" @click="ByNow" />
				</van-goods-action>
			</div>
		</cube-page>
		<van-sku style="width: 100%;" v-model="show" :sku="sku" :goods="goods"
		 :show-add-cart-btn="false" :show-soldout-sku="false" buy-text="确定"
			@buy-clicked="onBuyClicked" @sku-selected="skuSelected" @stepper-change="stepperChange">
			<template #sku-header-price="props">
				<div class="van-sku__goods-price">
					<span class="van-sku__price-symbol">￥</span>
					<span class="van-sku__price-num" v-if="!isP">{{ props.price }}</span>
					<span class="van-sku__price-num" v-else>{{ props.selectedSkuComb.price }}</span>
					<div style="padding-left:5px;font-size:12px;color:#969799;">
						零售价：￥
						<span v-if="!isP">{{line_price}}</span>
						<span v-else>{{ props.selectedSkuComb.line_price }}</span>
						<!-- {{line_price}} -->
					</div>
				</div>
			</template>
		</van-sku>
	</div>
</template>

<script>
	import CubePage from './TP/cube-page.vue'
	import Copyright from '@/components/TP/Copyright'
	import * as util from '@/utils/network'

	import {
		Toast,
		Dialog
	} from 'vant';

	export default {
		data() {
			return {
        storeId: this.$route.query.store_id,
				id: this.$route.query.id,
				detail: [],
				gcfg: [],
				cartnum: 0,

				specData: [],
				goods_sku_id: 0, // 规格id
				goods_price: 0,
				stock_num: 0,
				line_price: 0,

				goods_num: 1, //购买数量
				goods_sales: 0, //销量

				goods_spec_arr: [], // 记录规格的数组
				sku_hidden_arr: [], // 记录不显示的sku
				min_price: '',
				show: false,
				goods: {
					// 默认商品 sku 缩略图
					picture: 'https://b.yzcdn.cn/vant/sku/shoes-1.png'
				},
				sku: {
					// 所有sku规格类目与其值的从属关系，比如商品有颜色和尺码两大类规格，颜色下面又有红色和蓝色两个规格值。
					// 可以理解为一个商品可以有多个规格类目，一个规格类目下可以有多个规格值。
					tree: [],
					// 所有 sku 的组合列表，比如红色、M 码为一个 sku 组合，红色、S 码为另一个组合
					list: [],
					price: 0, // 默认价格（单位元）
					stock_num: 10, // 商品总库存
				},
				isP: false
			}
		},
		components: {
			CubePage,
			Copyright,
		},
		methods: {
			onBuyClicked() {
				if(this.storeId){

				}else{
					this.$router.push({
						path: '/ddcheckssu', //ddcheckhotel
						// query: {
						// 	goods_id: this.id,
						// 	goods_num: this.goods_num,
						// 	goods_sku_id: this.goods_sku_id
						// }
					})
				}
			},
			stepperChange(v) {
				this.goods_num = v
			},
			skuSelected(e) {
				let that = this;
				that.isP = false;
				let seleitem = e.selectedSkuComb
				if (e.selectedSkuComb != null) {
					let arr = that.sku.list;
					for (const elem of arr) {
						if (elem.goods_sku_id == seleitem.goods_sku_id) {
							that.isP = true
							that.sku.price = seleitem.price;
              that.sku.line_price = seleitem.line_price;
							that.stock_num = seleitem.stock_num;
							that.line_price = seleitem.line_price;
							that.goods_sku_id = seleitem.goods_sku_id;
							break;
						}
					}
				}
			},
			ByNow() {
				//this.show = true
				this.$router.push({
					path: '/ddcheckssu', //ddcheckhotel
					query: {
						goods_id: this.id,
					}
				})
			},
			axios_Request() {
				var url = "/addons/litestore/api.goods/detail"
				let that = this;

				//这里直接调用网络接口
				util.get(url, {
            store_id: that.storeId,
						'goods_id': that.id
					},
					function(result) {
						that.goods.picture = result.data.detail.image
						that.sku.price = result.data.min_price;
						that.sku.stock_num = result.data.stock_num;
						// 初始化商品多规格
						if (result.data.detail.spec_type === '20') {
							that.sku.tree = result.data.skus.tree
							that.sku.list = result.data.skus.list
							that.line_price = result.data.line_price
							that.stock_num = result.data.stock_num
							that.goods_sales = result.data.goods_sales
							that.goods_price = result.data.min_price
						} else {
							that.goods_sku_id = result.data.detail.spec[0].spec_sku_id
							that.goods_price = result.data.detail.spec[0].goods_price
							that.line_price = result.data.detail.spec[0].line_price
							that.stock_num = result.data.detail.spec[0].stock_num
							that.goods_sales = result.data.detail.spec[0].goods_sales
						}
						that.detail = result.data.detail
						that.specData = result.data.specData
						that.min_price = result.data.min_price
					},
				);
			},
		},
		created() {
			this.axios_Request();
			this.gcfg = this.$store.getters.getGcfg
		},
		watch: {
			"$store.state.gcfg": function() {
				this.gcfg = this.$store.getters.getGcfg
			}
		},
	}
</script>

<style scoped="scoped">
	/deep/ .van-popup--bottom{
		margin-bottom: 0 !important;
	}
	/deep/ .van-sku-header .van-image{
		width: 96px;
		height: 96px;
	}
	.swipebox {
		height: 300px;
	}

	.swipebox .van-swipe-item img {
		width: 100%;
	}

	.page_goods {
		height: 100%;
		position: absolute;
		width: 100%;
		top: 0;
		z-index: 28;
	}

	.page_goods .cube-page>.wrapper .content {
		margin: 0px;
	}
	.page_goods .titlec {
		font-size: 1.2em;
		color: #6d189e;
		font-weight: bold;
	}

	.page_goods .yuanjia {
		color: #666;
		text-decoration: line-through;
		margin-left: 1em;
	}

	.page_goods .modal_cont_box {
		box-sizing: border-box;
		padding: 10px 12px;
		background-color: white;
		margin-top: 1em;
	}

	.page_goods .til_conview {
		width: 100%;
		border-bottom: 1px solid #eee;
	}

	.page_goods .in-title {
		font-size: 1em;
		color: #6d189e;
		border-bottom: 2px solid #6d189e;
		width: 10em;
		display: block;
		margin: 0 auto;
		line-height: 2em;
		padding: 0em 0 0em 3em;
	}

	.page_goods .til_con {
		font-weight: bold;
		margin-left: 0.2em;
		font-size: 1.1em;
		margin-left: 0.68em;
	}

	.page_goods .tmall-types {
		margin-top: 1em;
	}

	.page_goods .tipstxt {
		font-size: 18px;
		color: rgb(88, 88, 88);
		margin-bottom: 5px;
	}

	.page_goods .radio_c {
		margin-left: -1em;
		padding-top: 0.3em;
	}

	.page_goods .radio_cc {
		display: inline;
		margin-left: 1em;
	}

	.page_goods .van-stepper__input[disabled] {
		color: white !important;
		background-color: #6d189e !important;
		z-index: -9 !important;
	}

	.goods-cont-li {
		width: 100%;
	}

	.page_goods .goods-cont-li img {
		/* max-width: 99% !important; */
		width: 100% !important;
		height: auto;
		display: block;
		margin: 0 auto;
		margin-left: 0rpx;
	}
</style>
